import { FC } from 'react'
import cn from 'classnames'

import style from '@src/components/PersonalInfo/Info.module.scss'
import { CheckBoxFormik } from '@src/components/common/CheckBoxFormik/CheckBoxFormik'

type InfoProps = {
    name?: string
    className?: string
    onchange?: () => void
    checked?: boolean
    checkbox?: boolean
}
// <div style="display: block;" bis_skin_checked="1">Нажимая кнопку «Зарегистрироваться», вы даете согласие на обработку моих персональных данных в соответствии с <a href="http://localhost:8078/files/document/29-politika_cosmostv_v_otnoshenii_obrabotki_personslnih_dannih_compressed.pdf" target="_blank" rel="noreferrer" style="margin-left: 3px;">условиями обработки </a> и подтверждаю, что до дачи согласия ознакомился с <a href="http://localhost:8078/files/document/29-politika_cosmostv_v_otnoshenii_obrabotki_personslnih_dannih_compressed.pdf" target="_blank" rel="noreferrer" style="margin-left: 3px;">разъяснением прав</a>, связанных с обработкой, механизмом их реализации, последствиями дачи согласия или отказа</div>
export const Info: FC<InfoProps> = ({
  checkbox, checked, onchange, name, className,
}) => (
  <div className={cn(style.description, className)}>
    {checkbox
      ? (
        <>
          <div>
            <CheckBoxFormik
              name="checkBoxRule"
              type="checkbox"
              onChange={onchange}
              checked={checked}
              label={(
                <span>
                  Нажимая кнопку «
                  {name}
                  », вы даете согласие
                  на обработку
                  {' '}
                  <a
                                        // eslint-disable-next-line max-len
                    href={`${process.env.REACT_APP_SITE_URL}/files/document/29-politika_cosmostv_v_otnoshenii_obrabotki_personslnih_dannih_compressed.pdf`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    персональных данных
                  </a>
                </span>
                            )}
            />
          </div>

        </>
      ) : (
        <div style={{ display: 'block' }}>
          Нажимая кнопку «
          {name}
          » вы соглашаетесь с тем, что ознакомились и согласны с договором об оказании услуги COSMOS TV
          {' '}
          <a
            // eslint-disable-next-line max-len
            href={`${process.env.REACT_APP_SITE_URL}/clients/documents/Договор%20об%20оказании%20услуги%20COSMOS%20TV%2007.06.2026`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '3px' }}
          >
            публичным договором об оказании услуг Cosmos TV
          </a>
          {' '}
          {/* и соглашаетесь с */}
          {/* <a */}
          {/*              // eslint-disable-next-line max-len */}
          {/*  href={`${process.env.REACT_APP_SITE_URL}/files/document/29-pravila-polsovania-service-cosmos-tv.pdf`} */}
          {/*  target="_blank" */}
          {/*  rel="noreferrer" */}
          {/*  style={{ marginLeft: '3px' }} */}
          {/* > */}
          {/*  правилами пользования сервисом Cosmos TV */}
          {/* </a> */}
          {/* {' '} */}
          {/* и */}
          {/* <a */}
          {/*              // eslint-disable-next-line max-len */}
          {/*  href={`${process.env.REACT_APP_SITE_URL}/files/document/29-politika_cosmostv_v_otnoshenii_obrabotki_personslnih_dannih_compressed.pdf`} */}
          {/*  target="_blank" */}
          {/*  rel="noreferrer" */}
          {/*  style={{ marginLeft: '3px' }} */}
          {/* > */}
          {/*  политикой обработки персональных данных */}
          {/* </a> */}
        </div>
      )}

  </div>
)
